import { render, staticRenderFns } from "./CostStatusBadge.vue?vue&type=template&id=6fde1a3f&scoped=true&"
import script from "./CostStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CostStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CostStatusBadge.vue?vue&type=style&index=0&id=6fde1a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde1a3f",
  null
  
)

export default component.exports